import { Button, Td, Text, Tr } from '@chakra-ui/react';
import * as React from 'react';

import { ISelectionState } from '@/imports/ui/useSelectionState';

import { Member_UserFragment } from './Member/graphql-types/Member_UserFragment';

type ISelectionDescriptionProps = {
  selection: ISelectionState<Member_UserFragment>;
  selectAll: () => void;
  selectMany: (members: Member_UserFragment[], allSelected: boolean) => void;
  colSpan: number;
  pageSize: number;
  totalCount: number;
  numPages: number;
  members: Member_UserFragment[];
};

export const SelectionDescription: React.FC<ISelectionDescriptionProps> = ({
  members,
  totalCount,
  numPages,
  selection,
  selectAll,
  selectMany,
  colSpan,
  pageSize,
}) => {
  const memberIds = members.map((member) => member._id);
  return !selection.allSelected &&
    selection.includedItems.length === pageSize &&
    selection.includedItems
      .map((m) => m._id)
      .every((i) => memberIds.includes(i)) ? (
    <Tr mx="4" mt="4" p="4" bg="gray.50" textAlign="center">
      <Td colSpan={colSpan}>
        <Text textAlign="center">
          Only the {memberIds.length} results on this page are selected.{' '}
          <Button
            variant="link"
            colorScheme="black"
            onClick={() => selectAll()}
          >
            Select All Results
          </Button>
        </Text>
      </Td>
    </Tr>
  ) : selection.allSelected && selection.excludedItems.length === 0 ? (
    // ...or if all items are selected and no items are excluded from that selection...
    <Tr mx="4" mt="4" p="4" bg="gray.50" textAlign="center">
      <Td colSpan={colSpan}>
        <Text textAlign="center">
          {`${totalCount} results are selected.`}
          <Button
            variant="link"
            colorScheme="black"
            onClick={() => selectMany(members, false)}
          >
            Select Only the {memberIds.length} Results on this Page
          </Button>
        </Text>
      </Td>
    </Tr>
  ) : null;
};
